import { render, staticRenderFns } from "./ArrobaMedellinVerticalCardAcademic.html?vue&type=template&id=a03212f0&scoped=true&external"
import script from "./ArrobaMedellinVerticalCardAcademic.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinVerticalCardAcademic.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinVerticalCardAcademic.scss?vue&type=style&index=0&id=a03212f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03212f0",
  null
  
)

export default component.exports